import React from 'react';
import { useTranslation } from 'react-i18next';
import Marquee from 'react-fast-marquee';

const galleryImages = [
  'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/6x7l7fco_local-concrete-pavers-near-me.jpg',
  'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/crivqsf0_PAIVER-55.jpg',
  'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/7i6mornw_gallery-a45-IMG_2282.jpg',
  'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/lcrljq7n_bedrock-decorative-concrete-pavers-768x512.jpg',
  'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/h5htasr0_WhatsApp%20Image%202026-01-14%20at%201.07.50%20PM%20%281%29.jpeg',
];

export const FeaturedGallery = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white overflow-hidden" data-testid="featured-gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        {/* Section Header */}
        <div className="text-center">
          <h2
            className="text-4xl sm:text-5xl font-bold text-[hsl(215,75%,16%)] mb-4 tracking-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            {t('gallery.title')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('gallery.subtitle')}
          </p>
        </div>
      </div>

      {/* Scrolling Gallery */}
      <Marquee
        gradient={true}
        gradientColor="white"
        gradientWidth={100}
        speed={30}
        pauseOnHover={true}
      >
        {galleryImages.map((image, index) => (
          <div
            key={index}
            className="mx-4 relative overflow-hidden rounded-lg shadow-lg"
            style={{ width: '400px', height: '300px' }}
            data-testid={`gallery-image-${index}`}
          >
            <img
              src={image}
              alt={`Project ${index + 1}`}
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end">
              <div className="p-6 text-white">
                <p className="font-semibold" style={{ fontFamily: 'Outfit' }}>
                  Featured Project
                </p>
              </div>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
};